import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { OperatingCapabilityRatio } from '../../types'

export const columns: (
    t: Function
) => GridColDefVNW<OperatingCapabilityRatio>[] = (_t) => [
    {
        field: 'report_month',
        headerName: 'month',
        width: 120,
        renderCell: ({ value }) => {
            const [year, month] = value.split('-')
            const monthNames = [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
            ]
            return (
                <div className="">
                    {monthNames[parseInt(month) - 1]} {year}
                </div>
            )
        },
    },
    {
        field: 'total_asset_turnover',
        headerName: 'total_asset_turnover',
        width: 200,
        align: 'right',
        renderCell: ({ value }) => (
            <div className="text-gray-900">
                {new Intl.NumberFormat('vi-VN', {
                    maximumFractionDigits: 2,
                }).format(value)}
                x
            </div>
        ),
    },
    {
        field: 'inventory_turnover',
        headerName: 'inventory_turnover',
        width: 250,
        align: 'right',
        renderCell: ({ value }) => (
            <div className="text-gray-900">
                {new Intl.NumberFormat('vi-VN', {
                    maximumFractionDigits: 2,
                }).format(value)}
                x
            </div>
        ),
    },
    {
        field: 'receivables_turnover',
        headerName: 'receivables_turnover',
        width: 300,
        align: 'right',
        renderCell: ({ value }) => (
            <div className="text-gray-900">
                {new Intl.NumberFormat('vi-VN', {
                    maximumFractionDigits: 2,
                }).format(value)}
                x
            </div>
        ),
    },
    {
        field: 'current_asset_turnover',
        headerName: 'current_asset_turnover',
        width: 300,
        align: 'right',
        renderCell: ({ value }) => (
            <div className="text-gray-900">
                {new Intl.NumberFormat('vi-VN', {
                    maximumFractionDigits: 2,
                }).format(value)}
                x
            </div>
        ),
    },
    {
        field: 'notes',
        headerName: 'notes',
        width: 300,
        flex: 1,
        renderCell: ({ value }) => (
            <div className="text-sm text-gray-600 truncate">{value || '-'}</div>
        ),
    },
]
